import { createContext } from "react";

export const defaultState = {
  tenantName: "",
  tenantId: "",
};

export const CommunityContext = createContext({ ...defaultState });
